import { ChangeEvent, FC, FormEvent, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import Page from "@app/shared/Page";
import PageHeader from "@app/shared/PageHeader";
import PageInner from "@app/shared/PageInner";
import PageSection from "@app/shared/PageSection";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESCheckbox } from "@app/shared/qes-standards/forms/Checkbox";
import RoleRestricted from "@app/user/RoleRestricted";
import Roles from "@app/user/roles";
import MemberSetService from "@app/members/memberSetService";

export const MemberSetCreate: FC = () => {
  const memberSetService = useRef(new MemberSetService()).current;
  const history = useHistory();

  const [description, setDescription] = useState("");
  const [name, setName] = useState("");
  const [isPrivate, setIsPrivate] = useState(true);

  const handleCancel = (): void => {
    history.goBack();
  }

  const handleNameChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setName(e.currentTarget.value);
  }

  const handleDescriptionChange = (e: ChangeEvent<HTMLTextAreaElement>): void => {
    setDescription(e.currentTarget.value);
  }

  const handleIsPrivateChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setIsPrivate(e.currentTarget.checked);
  }

  const handleFormSubmit = async (e: FormEvent<HTMLButtonElement>): Promise<void> => {
    e.preventDefault();

    await memberSetService.create(name, description, isPrivate);

    history.goBack();
  }

  return (
    <Page documentTitle="Create Member Population">
      <PageInner>
        <PageHeader title="Create Member Population..." />
        <PageSection>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <form className="form-horizontal" >

                  <div className="form-group row">
                    <label className="col-sm-2 col-form-label" htmlFor="memberSetName">Name</label>
                    <div className="col-sm-4">
                      <input
                        id="memberSetName"
                        type="text"
                        className="form-control"
                        placeholder="Member Population Name"
                        onChange={handleNameChange}
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-sm-2 col-form-label" htmlFor="memberSetDescription">Description</label>
                    <div className="col-sm-4">
                      <textarea
                        id="memberSetDescription"
                        className="form-control"
                        placeholder="Member Population Description"
                        rows={4}
                        onChange={handleDescriptionChange}
                      />
                    </div>
                  </div>
                  <RoleRestricted allowedRoles={[Roles.RESOURCE_ADMIN]}>
                    <div className="form-group row">
                      <QESCheckbox
                        containerClassName="offset-sm-2 col-sm-4"
                        label="This is a Private Project (can be administered only by you)"
                        checked={isPrivate}
                        onChange={handleIsPrivateChange}
                        testId="member-set-create__private"
                      />
                    </div>
                  </RoleRestricted>
                  <div className="form-group row mt30">
                    <div className="offset-sm-2 col-sm-4">
                      <QESButton qesTestId="member-set-create_create" onClick={handleFormSubmit}>Create</QESButton>
                      <QESButton qesTestId="member-set-create_cancel" qesType="primary-danger" className="ml10" onClick={handleCancel}>Cancel</QESButton>
                    </div>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </PageSection>
      </PageInner>
    </Page>
  );
};
